module.exports = __webpack_public_path__ + "assets/9343acede06ccf590ad747e5652d73e4.mp4";